export const environment = {
  production: true,
  socketUrl: 'https://moendoes.idlab.uantwerpen.be/',
  apiUrl: 'https://moendoes.idlab.uantwerpen.be/api/',
  pdfUrl: 'assets/pdfs/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts